const TOKEN_STORAGE_KEY = 'bearer_token';

export function getBearerToken(): string {
  const params = new URLSearchParams(window.location.search);
  const tokenFromUrl = params.get('bearerToken') || params.get('auth');
  const token = tokenFromUrl || localStorage.getItem(TOKEN_STORAGE_KEY) || '';

  return sanitizeToken(token);
}

export function persistBearerToken(token: string): void {
  const sanitizedToken = sanitizeToken(token);

  if (sanitizedToken) {
    localStorage.setItem(TOKEN_STORAGE_KEY, sanitizedToken);
  }
}

function sanitizeToken(token: string | null | undefined): string {
  if (!token || token === 'undefined') {
    return '';
  }

  return token.replace(/^Bearer\s+/i, '');
}
